import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "19562845508";
const WHATSAPP_MESSAGE = encodeURIComponent("¡Hola! Me interesa saber más sobre los productos Umbo.");

const WhatsAppButton = () => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 active:scale-95"
    >
      <MessageCircle className="h-7 w-7 fill-white" />
    </a>
  );
};

export default WhatsAppButton;
